export default "__VITE_ASSET__DtSIWZza__"